import { Tooltip } from 'antd'
import Flex from 'components/Flex'
import BlacklistIcon from 'components/icons/BlacklistIcon'
import ProgressCircle from 'components/ProgressCircle'
import { StyledTable } from 'components/TableStyles/TableStyles'
import ActionsDriveInfo from 'modules/DriveInfo/Partials/DriveInfoTable/ActionDriveInfo/index'
import StudentStatus from 'modules/Students/Partials/StudentsInfoTable/StudentStatus'
import React, { useState } from 'react'

import {
  BlacklistHeading,
  NavWrapper,
  OverlayFlex,
  StyledLi,
  StyledP,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'

const DriveInfoTable = ({
  studentsList,
  UserDriveList,
  studentDriveList,
  getSingleStudentData,
  deleteStudent,
  singleStudentData,
  onEditStudent,
  blacklistStudent,
  activeInactivateStatus,
  setUrl,
  degreeList,
  currentUrl,
  currentPage,
  setCurrentPage,
  setSelectedStudents,
  reInviteStudent,
  onSortValueChanged,
  loading,
}) => {
  const search = ''
  const [debounced, setDebounced] = useState(() => search)
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(search)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  React.useEffect(() => {
    if (search) {
      setUrl(`searchBy=${search}`)
    } else {
      setUrl('')
    }
    setCurrentPage(0)
  }, [debounced])
  const sortFilter = sort => {
    let sortOrder = ''
    if (sort == sortBy) {
      sortOrder = orderBy == 'asc' ? 'desc' : 'asc'
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSortBy(sort)
    onSortValueChanged(`sort=${sort}&order=${sortOrder}`)
  }

  const columns = [
    {
      title: 'Roll Number',
      dataIndex: 'uniRollNo',
      sorter: true,
      sortDirections: ['descend'],
      render: (text, data) => (
        <Flex spaceBetween>
          <StyledP textType="uppercase">{data?.student?.uniRollNo}</StyledP>
          {(data?.backlistedReason?.badConduct ||
            data?.backlistedReason?.feeNotPaid ||
            data?.backlistedReason?.lowAttendance) && (
            <Tooltip
              placement={'bottomLeft'}
              title={
                <OverlayFlex column>
                  <BlacklistHeading>Blacklisted for</BlacklistHeading>
                  <ul>
                    {data?.backlistedReason?.badConduct && (
                      <StyledLi>Bad Conduct</StyledLi>
                    )}
                    {data?.backlistedReason?.feeNotPaid && (
                      <StyledLi>Fee Not Paid</StyledLi>
                    )}
                    {data?.backlistedReason?.lowAttendance && (
                      <StyledLi>Low Attendence</StyledLi>
                    )}
                  </ul>
                </OverlayFlex>
              }
            >
              <div>
                <BlacklistIcon />
              </div>
            </Tooltip>
          )}
        </Flex>
      ),
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('uniRollNo')
          },
        }
      },
    },
    {
      title: 'Student Name',
      dataIndex: 'firstName',
      sorter: true,
      sortDirections: ['descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('firstName')
          },
        }
      },
      render: (text, item) => (
        <StyledP>
          {item?.student?.firstName} {item?.student?.middelName}{' '}
          {item?.student?.lastName}
        </StyledP>
      ),
    },
    {
      title: 'Batch',
      dataIndex: 'batch',
      sorter: true,
      sortDirections: ['descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('startedOn')
          },
        }
      },
      render: (text, item) => (
        <StyledP>
          {new Date(
            item?.currentCourse?.startedOn ??
              item?.student?.currentCourse?.startedOn * 1
          ).getFullYear() +
            '-' +
            new Date(
              item?.currentCourse?.endedOn ??
                item?.student?.currentCourse?.endedOn * 1
            ).getFullYear()}
        </StyledP>
      ),
    },
    {
      title: 'Deg & Department',
      dataIndex: 'deg_department',
      sorter: true,
      sortDirections: ['descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('deg_department')
          },
        }
      },
      render: (text, data) => (
        <StyledP>
          {data?.currentCourse?.degree ?? data?.student?.currentCourse?.degree}
        </StyledP>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: true,
      sortDirections: ['descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('status')
          },
        }
      },
      render: status => <StudentStatus status={status} />,
    },
    {
      title: 'completion',
      dataIndex: 'profileCompletionPerc',
      sorter: true,
      sortDirections: ['descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('profileCompletionPerc')
          },
        }
      },
      render: (text, data) => (
        <ProgressCircle
          progressRate={data?.student?.profileCompletionPerc}
          width="30px"
        />
      ),
    },

    {
      title: 'Action',
      dataIndex: 'id',
      render: (id, data) => (
        <ActionsDriveInfo
          studentId={id}
          id={data?.student?.id}
          data={data}
          getSingleStudentData={getSingleStudentData}
          deleteStudent={deleteStudent}
          singleStudentData={singleStudentData}
          onEditStudent={onEditStudent}
          blacklistStudent={blacklistStudent}
          activeInactivateStatus={activeInactivateStatus}
          reInviteStudent={reInviteStudent}
        />
      ),
    },
  ]
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedStudents(selectedRowKeys)
    },
    getCheckboxProps: record => ({
      disabled: record.roles === 'Disabled User',

      roles: record.roles,
    }),
  }
  const paginationChange = (page, pageSize) => {
    setUrl(`${currentUrl}`)
    setCurrentPage(page - 1)
  }

  return (
    <NavWrapper column>
      <StyledTable
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        rowKey="id"
        columns={columns}
        loading={loading}
        dataSource={studentDriveList?.candidateList?.result}
        pagination={{
          defaultPageSize: 10,
          current: currentPage + 1,
          onChange: (page, pageSize) => {
            paginationChange(page, pageSize)
          },
          total: studentDriveList?.candidateList?.count,
        }}
      />
    </NavWrapper>
  )
}

export default DriveInfoTable
